import React, { useState, useEffect } from 'react';
import { addMaterial, listMaterials, updateMaterial } from '../../services/materialCalculatorAPI';
import './AddMaterial.css';

const AddMaterial = () => {
  const [name, setName] = useState('');
  const [unit, setUnit] = useState('');
  const [price, setPrice] = useState('');
  const [message, setMessage] = useState('');

  const [materials, setMaterials] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  useEffect(() => {
    const fetchMaterials = async () => {
      const res = await listMaterials(); 
      setMaterials(res);
    };
    fetchMaterials();
  }, []);

  const refreshMaterials = async () => {
    const updated = await listMaterials();
    setMaterials(updated);
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    const parsedPrice = price === '' ? null : parseFloat(price);
    const res = await addMaterial({ name, unit, price_per_unit: parsedPrice });
    setMessage(res.message || 'Material added');
    setName('');
    setUnit('');
    setPrice('');
    refreshMaterials();
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    if (!selectedMaterial) return;
    const parsedPrice = price === '' ? null : parseFloat(price);
    const res = await updateMaterial(selectedMaterial.id, name, unit, parsedPrice);
    setMessage(res.message || 'Material updated');
    setSelectedMaterial(null);
    setName('');
    setUnit('');
    setPrice('');
    refreshMaterials();
  };

  const handleSelectMaterial = (material) => {
    setSelectedMaterial(material);
    setName(material.name);
    setUnit(material.unit);
    setPrice(material.price_per_unit !== null ? material.price_per_unit : '');
    setMessage('');
  };

  const handleCancelUpdate = () => {
    setSelectedMaterial(null);
    setName('');
    setUnit('');
    setPrice('');
    setMessage('');
  };

  const formatPrice = (val) => {
    const num = parseFloat(val);
    return isNaN(num) ? <em>Not uploaded</em> : `₹${num.toFixed(2)}`;
  };

  return (
    <div className="add-material-container">
      <h2 className="material-title">{selectedMaterial ? 'Update Material' : 'Add Material'}</h2>

      <form onSubmit={selectedMaterial ? handleUpdateSubmit : handleAddSubmit} className="add-material-form">
        <input
          type="text"
          className="input-field"
          placeholder="Material Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="text"
          className="input-field"
          placeholder="Unit (e.g., pcs)"
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          required
        />
        <input
          type="number"
          className="input-field"
          placeholder="Price per Unit (optional)"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          min="0"
          step="0.01"
        />
        <div className="button-group">
          <button type="submit" className="submit-button">
            {selectedMaterial ? 'Update Material' : 'Add Material'}
          </button>
          {selectedMaterial && (
            <button type="button" onClick={handleCancelUpdate} className="submit-button cancel">
              Cancel
            </button>
          )}
        </div>
      </form>

      {message && <p className="form-message">{message}</p>}

      <div className="material-search">
        <input
          type="text"
          placeholder="Search Material"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="input-field"
        />
        <div className="material-list">
          {materials
            .filter((m) => m.name.toLowerCase().includes(search.toLowerCase()))
            .map((m) => (
              <div
                key={m.id}
                className="material-item"
                onClick={() => handleSelectMaterial(m)}
              >
                <strong>{m.name}</strong> ({m.unit}) — {formatPrice(m.price_per_unit)}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default AddMaterial;
